import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';
import { EBuildingElevatorType } from '../../../packages/api-models/common/json_query';

export const selectBuildingLiftTypesType = createSelector(
  selectJsonQuery,
  jsonQuery => getTermsValue('building_lift_types_type')(jsonQuery) as EBuildingElevatorType[] | null,
);
